export const buildGeneralCollaborationsParams = (entity, filters = {}) => {
  const hasBothYears =
    filters?.yearRange?.[0] != null &&
    filters?.yearRange?.[1] != null &&
    Number.isInteger(Number(filters.yearRange[0])) &&
    Number.isInteger(Number(filters.yearRange[1]));

  return {
    entity_id: entity?.id,
    entity_type: (entity?.type || "institution").toLowerCase(),
    publication_year_start: hasBothYears ? Number(filters.yearRange[0]) : undefined,
    publication_year_end: hasBothYears ? Number(filters.yearRange[1]) : undefined,
    keywords: filters?.subjectArea && filters.subjectArea.length > 0 ? filters.subjectArea : undefined,
    keywords_operator: filters?.keywordsOperator || 'or',
    geography: filters?.geography,
    collaborator_type: filters?.collaboratorType,
    metric: filters?.metric,
  };
};
